import { avatar } from './tokens.js';
/** Stable colour pair per person, from the design tokens (all pairs pass WCAG AA). */
export function avatarColors(id) {
    let hash = 0;
    for (const char of id)
        hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
    return avatar[hash % avatar.length];
}
export function initials(name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    const first = parts[0]?.[0] ?? '?';
    return (parts.length > 1 ? first + parts.at(-1)[0] : first).toLocaleUpperCase('tr');
}
export function firstName(name) {
    return name.trim().split(/\s+/)[0] ?? name;
}
/** Text a little lighter than each avatar colour, readable on the dark theme. */
const MENTION_TEXT = { '#595ABA': '#A9AAF7', '#ED8B5D': '#F3A37B', '#6ACBDC': '#86D9E7', '#6BC676': '#8AD893', '#FCDF3C': '#FCE36A' };
/** A mention of someone in their own avatar colour: the text, and a faint tint behind it. */
export function mentionColors(id) {
    const { bg } = avatarColors(id);
    const [r, g, b] = [1, 3, 5].map((i) => parseInt(bg.slice(i, i + 2), 16));
    return { text: MENTION_TEXT[bg] ?? bg, tint: `rgba(${r}, ${g}, ${b}, 0.2)` };
}
//# sourceMappingURL=people.js.map